import React from 'react';
import loadable from 'utils/loadable';
import LoadingIndicator from 'components/LoadingIndicator';
import HomePageWrapper from 'containers/HomePageWrapper/Loadable';
import Resources from 'containers/Resources/Loadable';
import Book from 'containers/Book/Loadable';
import Topics from 'containers/Topics/Loadable';
import Topic from 'containers/Topic/Loadable';
import Signup from 'containers/Signup/Loadable';
import Login from 'containers/Login/Loadable';
import ForgotPassword from 'containers/ForgotPassword/Loadable';
import Account from 'containers/Account/Loadable';
import Favorites from 'containers/Favorites/Loadable';
import Assessments from 'containers/Assessments/Loadable';
import Assessment from 'containers/Assessment/Loadable';
import AssessmentResult from 'containers/AssessmentResult/Loadable';
import Person from 'containers/Person/Loadable';
import Podcast from 'containers/Podcast/Loadable';
import Video from 'containers/Video/Loadable';
import App from 'containers/App/Loadable';
import Organization from 'containers/Organization/Loadable';
import Article from 'containers/Article/Loadable';
import Editor from 'containers/Editor/Loadable';
import Blogs from 'containers/Blogs/Loadable';
import News from 'containers/News/Loadable';
import FAQ from 'containers/FAQ/Loadable';
import Company from 'containers/Company/Loadable';
import EditorLists from 'containers/EditorLists/Loadable';
import EditorList from 'containers/EditorList/Loadable';
import Sponsors from 'containers/Sponsors/Loadable';
import Sponsor from 'containers/Sponsor/Loadable';
import InCrisis from 'containers/InCrisis/Loadable';
import Program from 'containers/Program/Loadable';
import ClientLanding from 'containers/ClientLanding/Loadable';
import BestResources from 'containers/BestResources/Loadable';
const HowItWorks = loadable(() => import('containers/HowItWorks'), {
  fallback: <LoadingIndicator />,
});
const ClientResources = loadable(() => import('containers/ClientResources'), {
  fallback: <LoadingIndicator />,
});
const AdminToolsPage = loadable(() => import('containers/Admin'), {
  fallback: <LoadingIndicator />,
});
const AdminAssessmentTool = loadable(
  () => import('containers/AdminAssessmentTool'),
  {
    fallback: <LoadingIndicator />,
  },
);
const AdminAssessmentResultsTool = loadable(
  () => import('containers/AdminAssessmentResultsTool'),
  {
    fallback: <LoadingIndicator />,
  },
);
const AdminAssessmentValidationTool = loadable(
  () => import('containers/AdminAssessmentValidationTool'),
  {
    fallback: <LoadingIndicator />,
  },
);
const AdminClientsTool = loadable(() => import('containers/AdminClientsTool'), {
  fallback: <LoadingIndicator />,
});
const AdminHelpfulDataTool = loadable(
  () => import('containers/AdminHelpfulDataTool'),
  {
    fallback: <LoadingIndicator />,
  },
);
const AdminRichTextTool = loadable(
  () => import('containers/AdminRichTextTool'),
  {
    fallback: <LoadingIndicator />,
  },
);
const AdminUserReviewsTool = loadable(
  () => import('containers/AdminUserReviewsTool'),
  {
    fallback: <LoadingIndicator />,
  },
);
const AdminBestListsTool = loadable(
  () => import('containers/AdminBestListsTool'),
  {
    fallback: <LoadingIndicator />,
  },
);

const PrivacyPolicy = loadable(
  () => import('containers/PrivacyPolicy/PrivacyPolicyRoute'),
  {
    fallback: <LoadingIndicator />,
  },
);

const TermsOfUse = loadable(() => import('containers/TermsOfUse/TermsRoute'), {
  fallback: <LoadingIndicator />,
});

const Feedback = loadable(() => import('containers/Feedback'), {
  fallback: <LoadingIndicator />,
});

const Routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePageWrapper,
    exact: true,
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicy,
    exact: true,
  },
  {
    path: '/resources',
    name: 'Resources',
    component: Resources,
    exact: true,
  },
  {
    path: '/assessments',
    name: 'Assessments',
    component: Assessments,
    exact: true,
  },
  {
    path: '/assessments/:slug',
    name: 'Assessment',
    component: Assessment,
    exact: true,
  },
  {
    path: '/assessments/:slug/results',
    name: 'AssessmentResult',
    component: AssessmentResult,
    exact: true,
  },
  {
    path: '/assessments/:slug/:page',
    name: 'Assessment',
    component: Assessment,
    exact: true,
  },
  {
    path: '/books/:slug',
    name: 'Book',
    component: Book,
    exact: true,
  },
  {
    path: '/topics',
    name: 'Topics',
    component: Topics,
    exact: true,
  },
  {
    path: '/topics/:slug',
    name: 'Topic',
    component: Topic,
    exact: true,
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    exact: true,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    exact: true,
  },
  {
    path: '/forgot_password',
    name: 'Forgot Password',
    component: ForgotPassword,
    exact: true,
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    exact: true,
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: Favorites,
    exact: true,
  },
  {
    path: '/people/:slug',
    name: 'Person',
    component: Person,
    exact: true,
  },
  {
    path: '/podcasts/:slug',
    name: 'Podcast',
    component: Podcast,
    exact: true,
  },
  {
    path: '/videos/:slug',
    name: 'Video',
    component: Video,
    exact: true,
  },
  {
    path: '/apps/:slug',
    name: 'App',
    component: App,
    exact: true,
  },
  {
    path: '/organizations/:slug',
    name: 'Organization',
    component: Organization,
    exact: true,
  },
  {
    path: '/articles/:slug',
    name: 'Article',
    component: Article,
    exact: true,
  },
  {
    path: '/blogs/:slug',
    name: 'Article',
    component: Article,
    exact: true,
  },
  {
    path: '/editors/:slug',
    name: 'Editor',
    component: Editor,
    exact: true,
  },
  {
    path: '/blogs',
    name: 'Blogs',
    component: Blogs,
    exact: true,
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    exact: true,
  },
  {
    path: '/faqs/:slug',
    name: 'FAQs',
    component: FAQ,
    exact: true,
  },
  {
    path: '/lists',
    name: 'Lists',
    component: EditorLists,
    exact: true,
  },
  {
    path: '/lists/:slug',
    name: 'List',
    component: EditorList,
    exact: true,
  },
  {
    path: '/company/sponsors',
    name: 'sponsors',
    component: Sponsors,
    exact: true,
  },
  {
    path: '/company/sponsors/:slug',
    name: 'sponsor',
    component: Sponsor,
    exact: true,
  },
  {
    path: '/company/need-help',
    name: 'need-help',
    component: InCrisis,
    exact: true,
  },
  {
    path: '/in-crisis',
    name: 'need-help',
    component: InCrisis,
    exact: true,
  },
  {
    path: '/company',
    name: 'Company',
    component: Company,
    exact: false,
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    exact: true,
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsOfUse,
    exact: true,
  },
  {
    path: '/programs/:slug',
    name: 'program-page',
    component: Program,
    exact: true,
  },
  {
    path: '/admin',
    name: 'Admin Tool',
    component: AdminToolsPage,
    exact: true,
  },
  {
    path: '/admin/assessments-tool',
    name: 'Admin Assessment Tool',
    component: AdminAssessmentTool,
    exact: true,
  },
  {
    path: '/admin/assessments-validation-tool',
    name: 'Admin Assessment Validation Tool',
    component: AdminAssessmentValidationTool,
    exact: true,
  },
  {
    path: '/admin/clients-tool',
    name: 'Admin Clients Tool',
    component: AdminClientsTool,
    exact: true,
  },
  {
    path: '/admin/rich-text-tool',
    name: 'Admin Rich Text Tool',
    component: AdminRichTextTool,
    exact: true,
  },
  {
    path: '/admin/helpful-tool',
    name: 'Admin Was This Helpful Data Tool',
    component: AdminHelpfulDataTool,
    exact: true,
  },
  {
    path: '/admin/user-reviews-tool',
    name: 'Admin User Reviews Tool',
    component: AdminUserReviewsTool,
    exact: true,
  },
  {
    path: '/admin/assessments-results-tool',
    name: 'Admin Assessment Results Tool',
    component: AdminAssessmentResultsTool,
    exact: true,
  },
  {
    path: '/admin/best-lists-tool',
    name: 'Admin Best Lists Tool',
    component: AdminBestListsTool,
    exact: true,
  },
  {
    path: '/landing/:slug',
    name: 'Client Landing Page',
    component: ClientLanding,
    exact: true,
  },
  {
    path: '/bestlists/:topicSlug/:resourceSlug',
    name: 'BestResources',
    component: BestResources,
    exact: true,
  },
  {
    path: '/how-it-works',
    name: 'HowItWorks',
    component: HowItWorks,
    exact: true,
  },
  {
    path: '/client-resources',
    name: 'ClientResources',
    component: ClientResources,
    exact: true,
  },
  {
    path: '/user-resources',
    name: 'ClientResources',
    component: ClientResources,
    exact: true,
  },
];

export default Routes;
